import React from 'react';

export function ShareIcon() {
  return (
    <svg className="install-share-icon" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
      <path d="M12 3v12M12 3l-4 4M12 3l4 4M6 11H5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1h-1"
        fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

// One written guide per kind of device/browser. `steps` render as an ordered list.
export const GUIDES = {
  ios: {
    label: 'iPhone / iPad (Safari, Chrome, Edge, Firefox)',
    steps: [
      <>Tap the Share button <ShareIcon /> (Safari: bottom toolbar · Chrome / Edge: next to the address bar)</>,
      <>Scroll down and tap <strong>Add to Home Screen</strong></>,
      <>Tap <strong>Add</strong> — the Greek Ranking icon appears on your Home Screen</>
    ],
    note: 'Needs iOS 16.4 or newer for notifications. Opened inside Instagram/Facebook? Tap ⋯ → Open in Safari first.'
  },
  'android-chromium': {
    label: 'Android (Chrome, Edge, Samsung Internet)',
    steps: [
      <>Tap the <strong>⋮</strong> menu in the top-right corner</>,
      <>Tap <strong>Install app</strong> (or <strong>Add to Home screen</strong>)</>,
      <>Tap <strong>Install</strong> — the app icon appears with your other apps</>
    ]
  },
  'android-firefox': {
    label: 'Android (Firefox)',
    steps: [
      <>Tap the <strong>⋮</strong> menu</>,
      <>Tap <strong>Install</strong> (or <strong>Add to Home screen</strong>)</>,
      <>Tap <strong>Add</strong></>
    ]
  },
  'desktop-chromium': {
    label: 'Windows / Mac / Linux (Chrome, Edge, Opera)',
    steps: [
      <>Click the <strong>Install</strong> icon (a screen with a down arrow) at the right end of the address bar — or open the menu: Chrome ⋮ → <strong>Cast, save and share → Install page as app</strong> · Edge ⋯ → <strong>Apps → Install this site as an app</strong></>,
      <>Click <strong>Install</strong> — Greek Ranking opens in its own window and gets a desktop / Start menu shortcut</>
    ]
  },
  'mac-safari': {
    label: 'Mac (Safari 17+)',
    steps: [
      <>Click the Share button <ShareIcon /> in the toolbar, or open the <strong>File</strong> menu</>,
      <>Choose <strong>Add to Dock</strong></>,
      <>Click <strong>Add</strong></>
    ],
    note: 'Requires macOS Sonoma (Safari 17) or newer.'
  },
  'desktop-firefox': {
    label: 'Desktop Firefox',
    steps: [
      <>Firefox on computers can’t install web apps. Open this site in <strong>Chrome</strong>, <strong>Edge</strong> or <strong>Safari 17+</strong> to install it, or keep it as a bookmark / pinned tab.</>
    ],
    note: 'Notifications still work in Firefox — see below.'
  },
  'desktop-other': {
    label: 'Other browsers',
    steps: [
      <>Open the browser menu and look for <strong>Install app</strong>, <strong>Add to Home screen</strong> or <strong>Add to Dock</strong>. If there is none, open this site in Chrome, Edge or Safari.</>
    ]
  }
};

export const GUIDE_ORDER = ['ios', 'android-chromium', 'android-firefox', 'desktop-chromium', 'mac-safari', 'desktop-firefox'];

export function InstallSteps({ guideId }) {
  const guide = GUIDES[guideId] || GUIDES['desktop-other'];
  return (
    <>
      <ol className="install-steps">
        {guide.steps.map((s, i) => <li key={i}>{s}</li>)}
      </ol>
      {guide.note && <p className="install-note">{guide.note}</p>}
    </>
  );
}

// Steps to switch on push notifications once the app is installed (same on every device)
export function NotifySteps({ guideId }) {
  return (
    <ol className="install-steps">
      <li>
        {guideId === 'ios'
          ? <>Open Greek Ranking <strong>from its Home Screen icon</strong> — iPhone only allows notifications in the installed app</>
          : <>Open Greek Ranking (the installed app or this page)</>}
      </li>
      <li><strong>Sign in</strong> or create your free account</li>
      <li>Open <strong>🔔 Notifications</strong> in the menu and tap <strong>Turn on for this device</strong></li>
      <li>Tap <strong>Allow</strong> when your device asks</li>
    </ol>
  );
}
